// extracted by mini-css-extract-plugin
export default {"container":"Z0vjKG mz-inline-label"};